webpackJsonp([10],{

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ImageFrame',
    props: ['url']
});

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "@media only screen and (max-width:768px){iframe[data-v-44d2b8da]{width:85vw}}iframe[data-v-44d2b8da]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/ImageFrame.vue"],"names":[],"mappings":"AACA,yCACA,wBACI,UAAY,CACf,CACA,AACD,wBACE,UAAY,CACb","file":"ImageFrame.vue","sourcesContent":["\n@media only screen and (max-width: 768px) {\niframe[data-v-44d2b8da] {\n    width: 85vw;\n}\n}\niframe[data-v-44d2b8da] {\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(128);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("63c760ff", content, true, {});

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44d2b8da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "rel": "dns-prefetch",
      "src": this.url,
      "loading": "lazy",
      "title": "coworking bratislava 360",
      "height": "500",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageFrame__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ImageFrame__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ImageFrame: __WEBPACK_IMPORTED_MODULE_0__ImageFrame___default.a
  },
  name: 'Venue',
  metaInfo: {
    title: 'Contact & Address'
  },
  data: function data() {
    return {
      href: {
        iframes: ['https://www.google.com/maps/embed?pb=!4v1582901663306!6m8!1m7!1s-gKR6kPv7nCGjQnZA3YY1w!2m2!1d48.1446918639937!2d17.11542692379906!3f165.52516117951566!4f-7.062132056435175!5f1.3653623366680616']
      }
    };
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "a{color:hotpink}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/ContactVenue.vue"],"names":[],"mappings":"AACA,EACE,aAAe,CAChB","file":"ContactVenue.vue","sourcesContent":["\na {\n  color: hotpink;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(193);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("548ebfbf", content, true, {});

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Venue"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('a', {
    attrs: {
      "href": "https://www.openstreetmap.org/node/1096120193",
      "target": "_blank"
    }
  }, [_vm._v("Open Street Map")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.google.com/maps/place/Progressbar+hackerspace/@48.144557,17.1133019,17z/data=!3m1!4b1!4m5!3m4!1s0x476c8946152ff129:0x72ac0b6fccaf66fd!8m2!3d48.144557!4d17.1154906",
      "target": "_blank"
    }
  }, [_vm._v("Google Maps")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "width": "100%",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "src": "https://www.openstreetmap.org/export/embed.html?bbox=17.113958001136783%2C48.143727459609195%2C17.116854786872867%2C48.14537578584775&layer=mapnik&marker=48.14455162934517%2C17.115406394004822",
      "loading": "lazy"
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "tile is-vertical is-12"
  }, _vm._l((_vm.href.iframes), function(frame) {
    return _c('div', {
      staticClass: "column contains-iframe-to-center"
    }, [_c('ImageFrame', {
      key: frame,
      attrs: {
        "url": frame
      }
    })], 1)
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-5 content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n          📍 We are located on the first floor. "), _c('br'), _vm._v("\n          🚶‍♀️ You can access our space through grey doors next to the bike stand."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" 🚪 If you plan visit us during day, let us know in advance, so we can count on you.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Before visit, "), _c('a', {
    attrs: {
      "href": "https://t.me/coworkprogressbar"
    }
  }, [_vm._v("join our public telegram channel ahead ")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk"
    }
  }, [_vm._v("contact us via email")]), _vm._v("."), _c('br'), _vm._v("\n          See you soon 👋\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4 is-offset-2 content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            📯Address - postal "), _c('br')]), _vm._v(" "), _c('h3', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            Progressbar cowork & hackerspace,"), _c('br'), _vm._v("\n            Dunajská 7495/14,"), _c('br'), _vm._v("\n            811 08 Bratislava"), _c('br'), _vm._v("\n            Slovakia"), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            🧾 Billing details\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            Progressbar o.z."), _c('br'), _vm._v("\n            Dunajská 7495/14,"), _c('br'), _vm._v("\n            81108 Bratislava,"), _c('br'), _vm._v("\n            Slovenská republika"), _c('br'), _vm._v("\n\n            IČO: 42180023"), _c('br'), _vm._v("\n            DIČ: 2023612074"), _c('br'), _vm._v("\n\n            Registrované na MVSR zo dňa 15.7.2010 číslo spisu VVS/1-900/90-35964\n          ")])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.bb89aa284fcd0c36bbd3.js